// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head__3Yk_b","head_crumbs":"index_head_crumbs__2iM1y","head_line":"index_head_line__3VDoH","content":"index_content__3SA3D"};